document.addEventListener('DOMContentLoaded', function () {
  const tabContainer = document.querySelector('.page-tab-container');
  const pageSelections = JSON.parse(tabContainer.dataset.pageSelection);

  function loadScript(url) {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
  }

  function fetchPageContent(page) {
    return fetch(`/pages/${page}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('#MainContent');

        if (content) {
          const newDiv = document.createElement('div');
          newDiv.className = 'tab-content hidden';
          newDiv.id = 'top-tabbed-content';
          newDiv.setAttribute('data-page', page);

          const scripts = Array.from(content.querySelectorAll('script'));
          const contentWithoutScripts = content.cloneNode(true);
          newDiv.innerHTML = contentWithoutScripts.innerHTML;

          return newDiv;
        }
      });
  }

  const firstPage = pageSelections[0];
  fetchPageContent(firstPage).then((firstContent) => {
    if (firstContent) {
      const pageLoadSection = document.querySelector('section[id*="page_load"]');
      if (pageLoadSection) {
        pageLoadSection.insertAdjacentElement('afterend', firstContent);
      }
    }

    const remainingPages = pageSelections.slice(1);
    Promise.all(remainingPages.map(fetchPageContent)).then((fetchedContents) => {
      fetchedContents.forEach((content) => {
        if (content) {
          const pageLoadSection = document.querySelector('section[id*="page_load"]');
          if (pageLoadSection) {
            const lastInsertedElement = pageLoadSection.nextElementSibling;
            if (lastInsertedElement) {
              lastInsertedElement.insertAdjacentElement('afterend', content);
            } else {
              pageLoadSection.insertAdjacentElement('afterend', content);
            }
          }
        }
      });

      initializeTabButtons();
      initializeMobileTabs();
      const scriptUrl = "//shop.miracare.com/cdn/shop/t/66/assets/component-mvc-expanding-3-columns.js?v=97207153798842717091746431376";
      loadScript(scriptUrl);
    });
  });

  function initializeTabButtons() {
    setTimeout(() => {
      const tabButtons = document.querySelectorAll('.tab-button');
      const tabContents = document.querySelectorAll('.tab-content');
      const loadingIndicator = document.querySelector('.loading-indicator');

      function removeActiveClasses() {
        tabButtons.forEach((tabButton) => {
          tabButton.classList.remove('text-black', 'border-black', 'font-semibold');
          tabButton.classList.add('text-gray-500', 'border-transparent');
        });
      }

      function hideAllPages() {
        tabContents.forEach((content) => {
          content.classList.add('hidden');
        });
      }

      if (tabContents.length > 0) {
        tabContents[0].classList.remove('hidden');
        loadingIndicator.style.display = 'none';
      }

      tabButtons.forEach((tabButton, index) => {
        tabButton.addEventListener('click', function () {
          removeActiveClasses();
          hideAllPages();

          this.classList.add('text-black', 'border-black', 'font-semibold');
          this.classList.remove('text-gray-500', 'border-transparent');

          const pageToShow = pageSelections[index];
          const activePage = document.querySelector(`[data-page="${pageToShow}"]`);
          if (activePage) {
            activePage.classList.remove('hidden');
          }

          const tabbedContents = document.querySelectorAll('#top-tabbed-content');
          const visibleTabbedContent = Array.from(tabbedContents).find(
            (tabbedContent) => window.getComputedStyle(tabbedContent).display !== 'none',
          );

          if (visibleTabbedContent) {
            const stickyMenuHeight = document.querySelector('.page-tab-container')?.offsetHeight || 0;
            const offset = stickyMenuHeight + 100;
            const elementPosition = visibleTabbedContent.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        });
      });
    }, 2000);
  }

  function initializeMobileTabs() {
    const mobileTabs = document.getElementById('mobile-tabs');
    const tabContents = document.querySelectorAll('.tab-content');

    function hideAllPages() {
      tabContents.forEach((content) => {
        content.classList.add('hidden');
      });
    }

    mobileTabs.addEventListener('change', function () {
      const selectedIndex = this.value;
      const pageToShow = pageSelections[selectedIndex];

      hideAllPages();

      const activePage = document.querySelector(`[data-page="${pageToShow}"]`);
      if (activePage) {
        activePage.classList.remove('hidden');
      }

      const tabbedContents = document.querySelectorAll('#top-tabbed-content');
      const visibleTabbedContent = Array.from(tabbedContents).find(
        (tabbedContent) => window.getComputedStyle(tabbedContent).display !== 'none',
      );

      if (visibleTabbedContent) {
        const stickyMenuHeight = document.querySelector('.page-tab-container')?.offsetHeight || 0;
        const offset = stickyMenuHeight + 100;
        const elementPosition = visibleTabbedContent.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  }
});
